import styled from 'styled-components'

export const Container = styled.div``

export const SectionMargin = styled.div`
  padding: 0 24px;
  overflow-x: hidden;
`

export const Header = styled.div`
  > div {
    margin-bottom: 16px;

    > span {
      display: flex;
      margin: 0;
    }
  }
`

export const MyTickets = styled.div`
  display: flex;
  flex-direction: column;
`

export const HeroContainer = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 0;
`

export const HeroImage = styled.img`
  width: 100%;
  height: auto;
`

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 32px 0 40px;
`

export const Testimonials = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px 0 32px;
`

export const BannerCapTorcedor = styled.div`
  display: flex;
  margin: 24px 0 32px;

  img {
    width: 100%;
    height: auto;
  }
`

export const Payment = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const BottomSheetContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  h3 {
    margin: 24px 0 8px;
  }

  button {
    margin-top: 24px;
  }
`
